const bnifitSlideselect = document.querySelector(".ctm_benifits_slider");
if (bnifitSlideselect) {
  const bnifitSlider = new Swiper(".ctm_benifits_slider", {
    spaceBetween: 0,
    slidesPerView: 3,
    loop: false,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      200: {
        slidesPerView: 1.2,
        spaceBetween: 30,
      },
    },
  });
}
